// extracted by mini-css-extract-plugin
module.exports = {"container":"placeholder-carousel_container__1kKEJ","placeholder":"placeholder-carousel_placeholder__2Cw6s"};